import helpers from "./helpers";

export default {
    getPublicAccessToken(){
        if (Shopify.shop === 'mj-bale-int-dev.myshopify.com') {
            return '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'
        } else if (Shopify.shop === 'mj-bale-int-uat.myshopify.com') {
            return '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';
        } else if (Shopify.shop === 'mj-bale-international.myshopify.com') {
            return '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';
        } else if (Shopify.shop === 'mjbale.myshopify.com') {
            return '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';
        } else if (Shopify.shop === 'mjbale-test.myshopify.com') {
            return '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'
        }
        return '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';
    },
    getStorefrontToken(){
        if (Shopify.shop === 'mj-bale-int-dev.myshopify.com'){
            return 'eae1e4cf7e6a2d96e3822eef40c1d419'
        } else if (Shopify.shop === 'mj-bale-international.myshopify.com') {
            return 'c3baad2d737e5e24a9d46cdd5cc83dce';
        } else if (Shopify.shop === 'mjbale.myshopify.com') {
            return '7bfac442079243cd5107965cde580c15';
        } else if (Shopify.shop === 'mjbale-test.myshopify.com') {
            return '4cfabb83db34867e6e33717654a51ba4'
        }
        return '7dddcfd166e8236d7a5d10758cda8140'
    },
    getXhrRequestConfig() {
        // XHR request header is required to catch certain errors e.g. adding over quantity available
        // https://community.shopify.com/c/Shopify-Design/AJAX-POST-cart-add-js-NEVER-returns-422-only-200-OK-on/m-p/375736
        // https://stackoverflow.com/questions/17478731/whats-the-point-of-the-x-requested-with-header
        return {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        };
    },
}
